export default __webpack_public_path__ + "static/media/may-the-force.3775aa32.gif";